import type { ModelId } from '@/shared/types/common.types';

/** What can be followed: one element, or every element of one family type. */
export const WATCH_KINDS = ['element', 'family_type'] as const;
export type WatchKind = (typeof WATCH_KINDS)[number];

/**
 * Something to follow, identified the way the Notifications service matches Core's change
 * events: by Revit `UniqueId` within one model.
 */
export interface FollowTarget {
  readonly modelId: ModelId;
  readonly kind: WatchKind;
  /** The element's UniqueId, or the family type's. */
  readonly uniqueId: string;
  /** What the daily email calls it. Stored with the follow, so it never changes afterwards. */
  readonly label: string;
}

/** A follow the signed-in user holds. */
export interface Watch extends FollowTarget {
  readonly id: string;
  readonly createdAt: string;
}
